/* istanbul ignore file */
import type {BooleanStyleParamsKeys} from './stylesParams';
import type {ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export type ShouldRenderVarsKeys = keyof ReturnType<typeof getShouldRenderVars> | BooleanStyleParamsKeys;

export const getShouldRenderVars = (shouldRenderVarsFnParams: ShouldRenderVarsFnParams) => {
  const {booleans, isRTL} = shouldRenderVarsFnParams;

  return {
    dummyRenderValue: booleans.productPage_showDiscountName && isRTL,
  };
};
